import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import processSignatureHtmlForInlineImages from '../utils/processSignatureHtmlForInlineImages';
import { action } from 'satcheljs/lib/legacy';

export default action('setSignatureInUserOptions')(function setSignatureInUserOptions(
    signatureHtml: string,
    signatureText: string
): void {
    const userOptions = getUserConfiguration().UserOptions;
    userOptions.SignatureHtml = processSignatureHtmlForInlineImages(signatureHtml);
    userOptions.SignatureText = signatureText;
});
